<div class="homeowner_wrapper">
  <div class="homeowner_header_wrapper">
    <div class="row  homeowner_header_row">
      <div class="col-lg-7 col-md-8 col-sm-12 col-12 homeowner_header_col">
        <h1 class="header_title">A Prop Tech Residential Real Estate Rental & Property Management Company</h1>
        <div class="header_button_wrapper">
          <div class="header_button">
            <a class="header_button_cnt" href="/login">Owner Login</a>           
          </div>
          <div class="header_button list-property-btn">
            <a class="header_button_cnt" data-toggle="modal" data-target="#listPropertyModal">List Property</a>           
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-md-6 d-lg-flex d-none homeowner_header_img_wrapper">
        <img src="assets/images/owner img.jpg " class="header_img img-responsive" alt="YourOwnrROOM : Home Owners" />
      </div>
    </div>
  </div>
  <!-- Residential Rental Mangement -->
  <div style="padding-top: 32px;">
    <h1 class="section-heading ">Residential Rental Mangement</h1>
    <div class="service-catalogue">
      <h1 class="section-heading service-type-section-heading">SERVICE OFFERINGS</h1>
      <!-- <h4 class="section-subheading">Choose from a range of services and YourOwnROOM will take care of the rest.</h4> -->
      <div class="row justify-content-around" style="padding: 0px 12px;">
        <div class="col-lg-4 col-md-6 col-12 catalogue-item">
            <img class="img-responsive catalogue-item-img service-offering-img" src="assets/images/homeowners/Discovery.jpg" />
            <h2 class="catalogue-subheading">Discovery</h2>
            <div class="catalogue-underline"></div>
            <div class="catalogue-item-list">
              <p class="catalogue-item-list-item"> • Property listing</p>
              <p class="catalogue-item-list-item"> • Tenant discovery</p>
              <p class="catalogue-item-list-item"> • KYC verifications</p>
              <p class="catalogue-item-list-item"> • Rental agreements</p>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12 catalogue-item">
          <img class="img-responsive catalogue-item-img" src="assets/images/homeowners/Rental.jpg" />
          <h2 class="catalogue-subheading">Rentals</h2>
          <div class="catalogue-underline"></div>
          <div class="catalogue-item-list">
            <p class="catalogue-item-list-item"> • Property onboarding</p>
            <p class="catalogue-item-list-item"> • Tenant onboarding</p>
            <p class="catalogue-item-list-item"> • Service request management</p>
            <p class="catalogue-item-list-item"> • Audits</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12 catalogue-item">
          <img class="img-responsive catalogue-item-img" src="assets/images/homeowners/Invoice Payments.jpg" />
          <h2 class="catalogue-subheading">Invoice & Payments</h2>
            <div class="catalogue-underline"></div>
            <div class="catalogue-item-list">
              <p class="catalogue-item-list-item"> • Invoices</p>
              <p class="catalogue-item-list-item"> • Rental & deposit collections</p>
              <p class="catalogue-item-list-item"> • Renewals</p>
              <p class="catalogue-item-list-item"> • Exit settlements</p>
            </div>
        </div>
      </div>
    </div>
    <div class="service-htw-wrapper">
      <h1 class="section-heading">How it works</h1>
      
      <div class="row justify-content-md-between justify-content-center">
        <div class="col-lg-4 col-md-6 col-12 htw">
          <div class="hiw-img-wrapper">
            <img src="assets/images/owners/sign mou.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img">
          </div>              
          <h1 class="htw-subheading">1.Sign MOU & List Property.</h1>
          <p class="service-offering-details" style="margin-bottom: 20px">
            <strong>-</strong> Property Owners share property details like location, configuration, current state, property pictures, rental expectation, format of the asset - family or coliving.
          </p>
          <p class="service-offering-details" style="margin-bottom: 20px">
            <strong>-</strong>  Acquisition experts assess the same with our Platform intelligence and historical data. 
          </p>
          <p class="service-offering-details" style="margin-bottom: 20px">
            <strong>-</strong> Share a multi-year MoU which includes target rentals and terms & conditions. 
          </p>
          <p class="service-offering-details" style="margin-bottom: 20px">
            <strong>-</strong> Post signing the MoU we make the property live on our PropTech Platform.
          </p>
         
        </div>
        <!-- <div class="col-lg-3 col-md-6 col-12 htw">
          <img src="assets/images/owners/sign.png" alt="YourOwnROOM - Property" class="htw-img img-responsive">
          <h1 class="htw-subheading">2. </h1>
          <p class="service-offering-details">Our experts share best rents, price escalation and property configurations for your property for long term occupany.</p>
        </div> -->
        <div class="col-lg-4 col-md-6 col-12 htw">
          <div class="hiw-img-wrapper">
            <img src="assets/images/owners/onboard property.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img"  >
          </div>          
          <!-- <img src="assets/images/owners/onboard property.jpg" alt="YourOwnROOM - Property" class="htw-img img-responsive"> -->
          <h1 class="htw-subheading">2. Onboard Property & Tenants</h1>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Our Operations team then conducts a thorough Inspection of the property.</p>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Recommend repairs and maintenance and help HomeOwner with onboarding the property.</p>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Post Onboarding, our rental sales team actively promotes the property and look for suitable tenants and conduct site visits.</p>
          
        </div>
        <div class="col-lg-4 col-md-6 col-12 htw">
          <div class="hiw-img-wrapper">
            <img src="assets/images/owners/manage property.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img">
          </div>                        
          <h1 class="htw-subheading">3. Manage Property & Rentals.</h1>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> We find the right tenant and complete Rental Agreement and KYC</p>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Collect rent, managing service requests, conduct audits, manage renewals </p>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Conduct Exit inspection & settlement and property restoration.</p>
           
        </div>
      </div>
    </div>

  </div>
  
  <!-- Property Management services. -->
  <div style="padding-top: 32px;">
    <h1 class="section-heading ">Property Management Services</h1>
    <div class="service-catalogue">
      <h1 class="section-heading service-type-section-heading" style="margin: 0 !important;">SERVICE OFFERINGS</h1>
      <h4 class="section-subheading">Choose from a range of services and YourOwnROOM will take care of the rest.</h4>
      <div class="row justify-content-around" style="padding: 0px 12px;">
        <div class="col-lg-5  col-md-6 col-12 catalogue-item">
            <img class="img-responsive catalogue-item-img" src="assets/images/homeowners/Painting solution.jpg" />
            <h2 class="catalogue-subheading">Property Onboarding & Offboarding</h2>
                    <div class="catalogue-underline"></div>
                    <div class="catalogue-item-list">
                        <p class="catalogue-item-list-item"> • Painting - Interior, Exterior, POP</p>
                        <p class="catalogue-item-list-item"> • Deep Cleaning.</p>
                        <p class="catalogue-item-list-item"> • Repairs - Electrical, Carpentry, Plumbing, Civil Finishing Works.</p>
                        <p class="catalogue-item-list-item"> • Plastering Works. </p>
                        <p class="catalogue-item-list-item"> • Waterproofing Works.  </p>
                        <p class="catalogue-item-list-item"> • Pest Control Services. </p>
                    </div>
                </div>
                <div class="col-lg-5 col-md-6 col-12 catalogue-item">
                    <img class="img-responsive catalogue-item-img" src="assets/images/homeowners/Interiors & Project Solutions.jpg" />
                    <h2 class="catalogue-subheading">Property Renovation </h2>
                    <div class="catalogue-underline"></div>
                    <div class="catalogue-item-list">
                        <p class="catalogue-item-list-item"> • Painting - Interior, Exterior, POP</p>
                        <p class="catalogue-item-list-item"> • Deep Cleaning</p>
                        <p class="catalogue-item-list-item"> • Repairs - Electrical, Carpentry, Plumbing</p>
                        <p class="catalogue-item-list-item"> • Waterproofing</p>
                        <p class="catalogue-item-list-item"> • Civil Finishing Work, Tiling, Fabrication</p>
                    </div>
                </div>
                <div class="col-lg-5 col-md-6 col-12 catalogue-item">
                    <img class="img-responsive catalogue-item-img" src="assets/images/homeowners/On-demand Services.jpg" />
                    <h2 class="catalogue-subheading">Projects</h2>
                    <div class="catalogue-underline"></div>
                    <div class="catalogue-item-list">
                        <p class="catalogue-item-list-item"> • Large Scale Painting, POP, False Ceiling.</p>
                        <p class="catalogue-item-list-item"> • Interiors.</p>
                        <p class="catalogue-item-list-item"> • Tiling / Granite Laying.</p>
                        <p class="catalogue-item-list-item"> • Civil Work.</p>
                        <p class="catalogue-item-list-item"> • Fabrication.</p>
                        <p class="catalogue-item-list-item"> • Electrical Fitments.</p>
                        <p class="catalogue-item-list-item"> • Landscaping.</p>
                    </div>
      </div>
    </div>
    <div class="service-htw-wrapper">
      <h1 class="section-heading"  style="margin: 0 !important;">How it works</h1>
      
      <div class="row justify-content-between">
        <div class="col-lg-4 col-md-6 col-12 htw">
          <div class="hiw-img-wrapper">
            <img src="assets/images/owners/Scope Requirement.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img">
          </div>
          <!-- <img src="assets/images/owners/Scope Requirement.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img"> -->
          <h1 class="htw-subheading">1. Scope Requirements</h1>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Scope customer’s requirements - Painting, Interiors or Civil work related to Property Onboarding, Offboarding, Maintenance and Project Management.  </p>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Baseline Customer Budget and timeline. </p>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Organise a site visit to capture scope and measurement in details at the site.</p>
        </div>
        
        <div class="col-lg-4 col-md-6 col-12 htw">
          <div class="hiw-img-wrapper">
            <img src="assets/images/owners/Sign Sow.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img">
          </div>
          <!-- <img src="assets/images/owners/Sign Sow.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img"> -->
          <h1 class="htw-subheading">2. Sign SOW and issue advance</h1>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Present Statement of Work which includes the Scope, Bill of Material, Timelines, Dependencies, Permissions, Price and Payment terms. </p>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Sign Statement of Work.</p>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Receive advance payment and commence Project.</p>
        </div>
        <div class="col-lg-4 col-md-6 col-12 htw">
          <div class="hiw-img-wrapper">
            <img src="assets/images/owners/Track and manage project.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img">
          </div>
          <!-- <img src="assets/images/owners/Track and manage project.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img"> -->
          <h1 class="htw-subheading">3. Track and Manage Project</h1>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Operations Manager tracks and manages the work from start till completion. </p>
          <p class="service-offering-details" style="margin-bottom: 20px;"><strong>-</strong> Send regular status updates and inform the customer about the milestone completion and risks. Any delays due to any reasons are also informed. </p>
          
        </div>
      </div>
    </div>
  </div>
  <!-- Tabs -->
  <div class="services-tabs">    
    
    <div class="service-proptech" style="margin-top: 80px; margin-bottom: 32px;">
      <h1 class="section-heading2" style="width: 100%; text-align: center;"> INTEGRATED REAL ESTATE PLATFORM</h1>
      <div class="row proptech-wrapper">
        <div class="col-lg-3 col-md-4 col-sm-12 proptech-img-col">
          <img src="assets/images/proptech/ownerdb1.jpg" alt="YourOwnROOM - Owner Dashboard" class="proptech-img img-responsive">
        </div>
        <div class="col-lg-6 col-md-4 col-sm-12 proptech-col">
          <h3 class="proptech-content">Offering end-end property journey from listing your property online, searching verified tenants, digital service request management, tracking rental payments, property audits, renewals and online tenant settlements. Manage your Property through the Owner Dashboard on our Portal and Mobile App.</h3>
          <a class="googleplay-wrapper" href="https://play.google.com/store/apps/details?id=com.yourownroom.yorapp" target="_blank"><img src="assets/images/googleplay.png" class="googleplay img-responsive" /></a>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 proptech-img-col">
          <img src="assets/images/proptech/ownerdb2.jpg" alt="YourOwnROOM - Owner Dashboard" class="proptech-img img-responsive">
        </div>
      </div>
    </div>
    <div class="service-proptech-sm" style="margin-top: 80px; margin-bottom: 32px;">
      <h1 class="section-heading2" style="width: 100%; text-align: center; margin-bottom: 56px;">INTEGRATED REAL ESTATE PLATFORM</h1>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <h3 class="proptech-content" style="text-align: center">Offering end-end property journey from listing your property online, searching verified tenants, digital service request management, tracking rental payments, property audits, renewals and online tenant settlements. Manage your Property through the Owner Dashboard on our Portal and Mobile App.</h3>
          
        </div>
        <div class="col-md-6 col-sm-6 col-6">
          <img src="assets/images/proptech/ownerdb1.jpg" alt="YourOwnROOM - Owner Dashboard" class="proptech-img img-responsive">
        </div>
        <div class="col-md-6 col-sm-6 col-6" style="display: flex; justify-content: flex-end;">
          <img src="assets/images/proptech/ownerdb2.jpg" alt="YourOwnROOM - Owner Dashboard" class="proptech-img img-responsive">
        </div>
      </div>
      <a class="googleplay-wrapper"  href="https://play.google.com/store/apps/details?id=com.yourownroom.yorapp" target="_blank"><img style="margin-top: 32px !important;" src="assets/images/googleplay.png" class="googleplay img-responsive" /></a>
    </div>
  </div>

  <!-- SECTION -> OWNER TESTIMONIALS -->
  <div class="testimony-section-wrapper">
    <p [routerLink]="['/testimony']" class="viewAll">View All</p>
    <h1 class="section-heading2 section-head-text-align"> Owner Testimonials </h1>   
    <h1 class="owner-testimony-headings testimony-subheading"> Hear what some owners have to say about us! </h1>
    <div class="testimony_container">            
        <div class="testimonial_wrapper" id="testimony_carousal">
            <div class="col-lg-4 testimonial_card_video">
                <div class="testimonial-video-wrapper" >
                    <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/ANprt_nTEak" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>                        
            <div class="col-lg-4 testimonial_card_video">
              <div class="testimonial-video-wrapper" >
                  <iframe class="video_testimony" src="https://www.youtube.com/embed/dJFALaEPe9A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
              </div>
            </div>
            
            <div class="col-lg-4 testimonial_card_video">
              <div class="testimonial-video-wrapper" >
                  <iframe class="video_testimony" src="https://www.youtube.com/embed/tQfMioGKlhg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
              </div>
            </div>
            <div class="col-lg-4 testimonial_card_video">
                <div class="testimonial-video-wrapper" >
                    <iframe class="video_testimony" src="https://www.youtube.com/embed/uiUy8nFhPJE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
                </div>
            </div>
            <div class="col-lg-4 testimonial_card_video">
                <div class="testimonial-video-wrapper" >
                    <iframe class="video_testimony" src="https://www.youtube.com/embed/rEt9myoQf-0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
                </div>
            </div>
            
            <div class="col-lg-4 testimonial_card_video">
              <div class="testimonial-video-wrapper" >
                  <iframe class="video_testimony" src="https://www.youtube.com/embed/0NbX-o-ITc0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
              </div>
            </div>            
            
            
            
            <div class="col-lg-4 testimonial_card_video">
              <div class="testimonial-video-wrapper" >
                  <iframe class="video_testimony" src="https://www.youtube.com/embed/6by-yUsUKNU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
              </div>
            </div>
            
            <div class="col-lg-4 testimonial_card_video">
              <div class="testimonial-video-wrapper" >
                  <iframe class="video_testimony" src="https://www.youtube.com/embed/7uEZ3u6Ni80" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
              </div>
            </div>            
            <div class="col-lg-4 testimonial_card_video">
                <div class="testimonial-video-wrapper" >
                    <iframe class="video_testimony" src="https://www.youtube.com/embed/P4H4HOcsflA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
                </div>
            </div>            
            <div class="col-lg-4 testimonial_card_video">
              <div class="testimonial-video-wrapper" >
                  <iframe class="video_testimony" src="https://www.youtube.com/embed/GPpJOrgOjm0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
              </div>
            </div>  
            
            <div class="col-lg-4 testimonial_card_video">
              <div class="testimonial-video-wrapper" >
                  <iframe class="video_testimony" src="https://www.youtube.com/embed/XxAfM9Mx7xA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
              </div>
            </div>            
        </div>        
        <div >
            <div class="scroll_indicator_wrapper">
                <img src="assets/images/left-arrow.svg" (click)="videoTestimonialLeft()" class="scroll_indicator_left" alt="Residential Real Estate Asset Management Company">
                <img src="assets/images/right-arrow.svg" (click)="videoTestimonialRight()" class="scroll_indicator_right" alt="Residential Real Estate Asset Management Company">
            </div>
        </div>
    </div>
  </div>

  <!--SECTION -> In The News -->
  <div class="news-section">        
    <h1 class="section-heading2 section-head-text-align">  In the news  </h1>   
    <div class="news_details_wrapper">
        <div class="yor_news" id="news_carousal">
            <div class="news col-12 col-lg-3 col-md-4">
                <a href="https://startupstorymedia.com/startuptv/prop-tech-is-the-new-growth-catalyst-in-residential-real-estate-prabhat-kumar-tiwary-yourownroom/" target="_blank">
                    <img src="assets/images/news/startup-story.png" alt="YourOwnROOM News" style="width: 140px;">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-md-4">
                <a href="https://yourstory.com/2017/02/yourownrooms-mantra-for-profitable-scaling/" target="_blank">
                    <img src="assets/images/news/news_yourstory.png" alt="YourOwnROOM News">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="http://bwdisrupt.businessworld.in/article/YourOwnRoom-a-750K-Seed-Funded-Co-living-Home-Rental-Company-Expands-Footprint-in-Bangalore-Pune/08-10-2018-161713/" target="_blank">
                    <img src="assets/images/news/news_full-Disrupt-logo.png" alt="YourOwnROOM News">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="http://www.deccanherald.com/content/594969/yourownroom-helps-singles-find-their.html" target="_blank">
                    <img src="assets/images/news/news_deccan.jpeg" alt="YourOwnROOM News">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="https://thetechpanda.com/2017/10/04/startup-millennials-apartments/" target="_blank">
                    <img src="assets/images/news/news_TheTechPanda.png" alt="YourOwnROOM News">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="http://www.siliconindia.com/magazine/startup-of-the-year-special-october-2016/" target="_blank">
                    <img src="assets/images/news/news_siliconindia.gif" alt="YourOwnROOM News">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="https://www.indianweb2.com/search?q=yourownroom" target="_blank">
                    <img src="assets/images/news/news_indianweb2.png" alt="YourOwnROOM News">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="https://m.dailyhunt.in/news/india/english/yourstory-epaper-yourstory/amid+coronavirus+how+proptech+rental+yourownroom+is+handling+tenants+and+scaling+up+its+platform-newsid-n177954266" target="_blank">
                    <img src="assets/images/news/news_dailyhunt.png" alt="YourOwnROOM News">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="https://www.onlinemarketplaces.com/?s=yourownroom" target="_blank">
                    <img src="assets/images/news/news_propertyportal.png" alt="YourOwnROOM News">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="http://epaper.prabhatkhabar.com/c/10229063" target="_blank">
                    <img src="assets/images/news/news_prabhatkhabar.jpg" alt="YourOwnROOM News">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="http://www.bangaloreinsider.com/yourownroom/" target="_blank">
                    <img src="assets/images/news/bangalore-insider.png">
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="http://www.thenewsminute.com/article/new-breed-startups-wants-solve-problems-house-renters-65949" target="_blank">
                    <img src="assets/images/news/news_thenewsmnt.jpg" >
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="https://www.bitosaglobal.org/news/14654" target="_blank">
                    <img src="assets/images/news/bitosa_logo.png" >
                </a>
            </div>
            <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                <a href="https://paulwriter.com/paul-writer-unveiled-namma-bengaluru-hot-brands-2019/" target="_blank">
                    <img src="assets/images/news/Paulwriter.png">
                </a>
            </div>
        </div>
    </div>
    <div>
        <div class="scroll_indicator_wrapper news-indicator">
            <img src="assets/images/left-arrow.svg" (click)="newsLeft()" class="scroll_indicator_left" alt="Residential Real Estate Asset Management Company">
            <img src="assets/images/right-arrow.svg" (click)="newsRight()" class="scroll_indicator_right" alt="Residential Real Estate Asset Management Company">
        </div>
    </div>
  </div>

  <!-- SECTION -> BLOGS & ARTICLES -->
  <div class="blog-wrapper">        
    <h1 class="section-heading2 section-head-text-align"> Blogs & Articles  </h1>   
    <div class="blog_container">
        <div class="blogs_wrapper" id="blogs_carousal">
            <div class="col-lg-4 blog_card" >
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="../../assets/images/guest_article_img_1.jpg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a class="blog_head" href="http://www.businessworld.in/article/De-mystifying-REIT-Real-Estate-Investment-Trust/24-08-2021-401576/" target="_blank">De-mystifying REIT: Real Estate Investment Trust</a>
                    <p class="blog_body">Real Estate Investment Trusts (REITs) are undoubtedly the safest investment options in the Indian market today. However...</p>
                </div>
            </div>
            <div class="col-lg-4 blog_card" >
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="../../assets/images/sachinblogjpeg.jpeg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a class="blog_head" href="https://tail-winds.medium.com/the-end-of-real-estate-silos-welcome-surveillance-d24d749f77d8" target="_blank">Rental & Property Management Companies</a>
                    <p class="blog_body">The End of Real Estate ‘Silos’ -Welcome Surveillance...</p>
                </div>
            </div>
            <div class="col-lg-4 blog_card" >
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="../../assets/images/griclub.jpg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a class="blog_head" href="https://www.griclub.org/news/real-estate/rental-property-management-companies_1584.html" target="_blank">Rental & Property Management Companies</a>
                    <p class="blog_body">Real estate industry in India is expected to grow five-fold to $1 trillion by 2030 and a significant percentage of this is Residential Real Estate...</p>
                </div>
            </div>
            <div class="col-lg-4 blog_card" >
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="../../assets/images/blog10.jpg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a class="blog_head" href="http://www.businessworld.in/article/Decoding-Model-Tenancy-Act/09-07-2021-395999/" target="_blank">Decoding Model Tenancy Act</a>
                    <p class="blog_body">Acts like RERA and Model Tenancy are now finalized, ready to set the housing sector right. While RERA was more focused around formalizing and building trust ...</p>
                </div>
            </div>
            <div class="col-lg-4 blog_card" >
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="https://i2.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/06/RERA-YOR.jpeg?resize=294%2C171&ssl=1" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a class="blog_head" href="http://www.businessworld.in/article/How-RERA-Is-Changing-The-Landscape-of-Residential-Real-Estate-/17-06-2021-393482/" target="_blank">How RERA Is Changing The Landscape Of Residential Real Estate?</a>
                    <p class="blog_body">With the prevailing discrepancies and issues in India's real estate sector, a concrete step was taken by the...</p>
                </div>
            </div>
            <div class="col-lg-4 blog_card">
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="https://i1.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/03/Prabhat-guest-post-4.png?resize=400%2C250&ssl=1" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a href="https://yourstory.com/2021/01/challenges-residential-real-estate-proptech/amp" class="blog_head">The Many Challenges in Residential Real Estate</a>
                    <p class="blog_body">In the early 2000s, general euphoria engulfed the Nation, especially the youth, induced by bright new...</p>
                </div>
            </div>
            <div class="col-lg-4 blog_card">
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="https://i1.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/03/Prabhat-gues-post-3.jpeg?resize=400%2C250&ssl=1" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a href="https://www.peoplematters.in/site/interstitial?return_to=%2Fblog%2Flife-at-work%2Fhome-is-the-defacto-workplace-and-wfh-the-new-normal-25523" class="blog_head">Home is the defacto workplace and “WFH” the new normal!</a>
                    <p class="blog_body">Did we ever think that words like “Social Distance”, “Lockdown” and “Quarantine” will become such an...</p>
                </div>
            </div>
            <div class="col-lg-4 blog_card">
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="https://miro.medium.com/max/1494/1*6y6NCuTanOofKe9MRTh_gQ.png" class="blog_img" alt="Yourownroom Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a class="blog_head" href="https://tail-winds.medium.com/the-return-of-indian-residential-real-estate-2dc01ff4b656" target="_blank">The Return of Indian Residential Real Estate</a>
                    <p class="blog_body">The property rates in India between 2000–2010 grew by 52%( in leading 7 cities). Decade after that it has grown only by 32% […]</p>
                </div>
            </div>
            <div class="col-lg-4 blog_card">
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="https://yourownroom.com/blog/wp-content/uploads/2020/03/The-outbreak-of-the-coronavirus-and-preventive-measures-that-one-should-follow.png" class="blog_img" alt="Yourownroom Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a href="https://yourownroom.com/blog/outbreak-coronavirus-preventive-measures-one-follow/" class="blog_head">The Outbreak Of the Coronavirus and Preventive Measures</a>
                    <p class="blog_body">From dropped conferences to shutdowns of hardware suppliers, the deadly […]</p>
                </div>
            </div>
            <div class="col-lg-4 blog_card">
                <div class="blog_img_wrapper">
                    <div class="blog_img_inner_wrapper">
                    <img src="https://yourownroom.com/blog/wp-content/uploads/2019/12/Untitled.jpg" class="blog_img" alt="Yourownroom Blogs">
                    </div>
                </div>
                <div class="blog_detail">
                    <a href="https://yourownroom.com/blog/your-own-room-indias-co-living-market/" class="blog_head">What Takes YourOwnRoom to India’s $6.5B Co-Living Market</a>
                    <p class="blog_body">India’s rapidly growing co-living market is currently valued at $6.5 billion, and is […]</p>  
                </div>
            </div>
        </div>
    </div>
    <div >
        <div class="scroll_indicator_wrapper">
            <img src="assets/images/left-arrow.svg" (click)="blogLeft()" class="scroll_indicator_left" alt="Residential Real Estate Asset Management Company">
            <img src="assets/images/right-arrow.svg" (click)="blogRight()" class="scroll_indicator_right" alt="Residential Real Estate Asset Management Company">
        </div>
    </div>        
  </div>
</div>

<!-- LIST YOUR PROPERTY MODAL -->
<div class="modal fade" id="listPropertyModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
          <div class="modal-body">
              <div style="display: flex; justify-content: end; position: absolute; top:-10px; right: -5px; cursor: pointer;">
                  <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
              </div>
              <h1 style="font-weight: 600;"> List Your Property </h1>
              <div>
                <form role="form">
                  <div class="form-section">
                    <h3 class="form_heads"> Property Details: </h3>
                    <div class="row form_row">
                      <div class="form-group col-md-12">
                        <input class="form-control" name="name" placeholder=" Address" type="text" [ngModel]="owner.address" (ngModelChange)="onAddressChange($event)" >              
                      </div>                      
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">                        
                        <select class="form-control" name="city" [ngModel]="owner.city" (ngModelChange)="onCityChange($event)">
                          <option value="city" disabled> City </option>                          
                          <option *ngFor="let c of cityList" [ngValue]="c.id">{{c.text}}</option>
                        </select>                         
                      </div>
                      <div class="form-group col-md-6">
                        <select class="form-control" name="state" [ngModel] = "owner.state" (ngModelChange)="onStateChange($event)">
                          <option value="state" disabled> State </option>
                          <option *ngFor="let list of stateList" [ngValue]="list.id"> {{ list.text }} </option>
                        </select> 
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input class="form-control" name="zip" placeholder="Zipcode" type="text" [ngModel]="owner.zip" (ngModelChange)="onZipChange($event)" />
                      </div>
                    </div>
                  </div>
                  <div class="form-section">
                    <h3 class="form_heads"> Owner Details:</h3>
                      <div class="row form_row">
                        <div class="form-group col-md-6">
                          <input class="form-control" name="name"  placeholder="Name " type="text" [ngModel]="owner.name" (ngModelChange)="onOwnerNameChange($event)" >              
                        </div>
                        <div class="form-group col-md-6">
                          <input class="form-control" name="phone" placeholder="Phone " type="text" [ngModel]="owner.phone" (ngModelChange)="onOwnerPhoneChange($event)" >              
                        </div>
                      </div>                      
                  </div>
                  <div class="form-section">
                    <h3 class="form_heads"> Management Services: </h3>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <input type="radio" name="mngtServices" id="rms" value="rms" class="mr-2" [ngModel]="managementServices" (ngModelChange)="onRentalProgramChange($event)" >
                          <label for="rms" class="service_name" >Rental Management service</label>
                      </div>
                      <div class="form-group col-md-6">
                          <input type="radio" name="mngtServices" id="pms" value="pms" class="mr-2" [ngModel]="managementServices" (ngModelChange)="onRentalProgramChange($event)">
                            <label for="pms" class="service_name">Property Management Service</label>
                      </div> 
                    </div>
                  </div>
                  <div *ngIf="rentalMngtServices == true" class="form-section">
                    <h3 class="form_heads"> Owner Expectations:</h3>
                      <div class="row form_row">
                        <div class="form-group col-md-6">
                          <select class="form-control" name="tenant" [ngModel]="owner.tenant" (ngModelChange)="onTenantTypeChange($event)" >
                            <option value="tenant" disabled> Type of Tenants </option>
                            <option *ngFor="let c of tenantType" [ngValue]="c.id">{{c.text}}</option>
                          </select>                         
                        </div>
                        <div class="form-group col-md-6">
                          <select class="form-control" name="gender" [ngModel]="owner.gender" (ngModelChange)="onGenderChange($event)">
                            <option value="gender" disabled> Gender </option>
                            <option *ngFor="let c of genderType" [ngValue]="c.id">{{c.text}}</option>
                          </select>                         
                        </div>
                      </div>
                      <div class="row form_row">
                        <div class="form-group col-md-6">
                          <input class="form-control" name="rent"  placeholder="Rent" type="text" [ngModel]="owner.rent" (ngModelChange)="onRentChange($event)" >              
                        </div>
                        <div class="form-group col-md-6">
                          <input class="form-control" name="deposit" placeholder="Deposit " type="text" [ngModel]="owner.deposit" (ngModelChange)="onDepositChange($event)" >              
                        </div>
                      </div>
                      <div class="row form_row">
                        <div class="form-group col-md-6">
                          <textarea class="form-control" placeholder="Additional Requirement (if any) " style="width: 100%;"></textarea>
                        </div>
                        <div class="form-group col-md-6 file_upload_container">
                          <input type="file" class="upload_box" multiple (change)="onAddImagesUpload($event)" placeholder="Upload file" accept=".png,.jpg, .jpeg" style="width: 100%;">
                        </div>
                      </div>
                  </div>   
                  <div *ngIf="propertyMngtServices == true" class="form-section">
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <select class="form-control" name="service_type" [ngModel]="serviceType" (ngModelChange)="onServiceTypeChange($event)" >
                          <option value="service_type" disabled> Type of Services </option>
                          <option *ngFor="let sReq of serviceList" [ngValue]="sReq.id">{{sReq.text}}</option>
                        </select>                         
                      </div>
                      <div class="form-group col-md-6">                        
                        <input class="col-md-12 form-control"  name="start_date" 
                                [ngModel]="owner.start_date" (ngModelChange)="onStartDateChange($event)" type="text" onfocus="(this.type='date')" id="date" >
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6">
                        <textarea class="form-control" placeholder="Details of Service" style="width: 100%;" ></textarea>
                      </div>  
                      <div class="form-group col-md-6">
                        <textarea class="form-control" placeholder="Additional Requirement (if any)" style="width: 100%;" ></textarea>
                      </div>
                    </div>
                    <div class="row form_row">
                      <div class="form-group col-md-6 file_upload_container">
                        <input type="file" aria-placeholder="Upload" class="upload_box" multiple (change)="onAddDefectImagesUpload($event)" placeholder="Upload file" accept=".png,.jpg, .jpeg" style="width: 100%;">
                      </div>
                    </div>
                  </div>                                                   
                  <div class="row form_row" style="margin-top: 20px;">
                    <div class="col-md-12 d-flex justify-content-center">
                      <button type="button" class="submit_button" (click)="onSubmitPropertyListing()"> Submit </button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
    </div>
  </div>
</div>